// visitors.state.ts
export interface IVisitorsState {
    visitors: any[];
    reasons: any[];
    destinations: any[];
    selectedVisitor: any;
 }
 
 export const initialVisitorsState: IVisitorsState = {
    visitors: [],
    reasons: [],
    destinations: [],
    selectedVisitor: null
 };